import { render, staticRenderFns } from "./sessions.vue?vue&type=template&id=d2806b52&"
import script from "./sessions.vue?vue&type=script&lang=js&"
export * from "./sessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports